export const LAYOUT_VENDOR_FINANCE_HOME = '/app/home'

export const LAYOUT_VENDOR_FINANCE_PANEL = '/app/finance/panel'

export const LAYOUT_VENDOR_FINANCE_PO_ROOT = '/app/finance/purchase-order'
export const LAYOUT_VENDOR_FINANCE_PO_LIST = '/app/finance/purchase-order/list'
export const LAYOUT_VENDOR_FINANCE_PO_SHOW = (id) => `/app/finance/purchase-order/show/${id}`

export const LAYOUT_VENDOR_FINANCE_INVOICE_ROOT = '/app/finance/invoice/vendor'
export const LAYOUT_VENDOR_FINANCE_INVOICE_LIST = '/app/finance/invoice/vendor/list'
export const LAYOUT_VENDOR_FINANCE_INVOICE_SHOW = (id) => `/app/finance/invoice/vendor/show/${id}`

export const LAYOUT_VENDOR_FINANCE_PAYMENT_ROOT = '/app/finance/payment'
export const LAYOUT_VENDOR_FINANCE_PAYMENT_LIST = '/app/finance/payment/vendor/list'
